export default {
  'NL': {
    id: 1,
    prefix: '0031'
  },
  'DE': {
    id: 2,
    prefix: '0049'
  },
  'BE': {
    id: 3,
    prefix: '0032'
  },
  'FR': {
    id: 4
  },
  'UK': {
    id: 5
  },
  'LU': {
    id:  6
  }
}

export function getCountry() {
  const country = (localStorage.getItem('COUNTRY') || 'NL').toLocaleLowerCase()
  if (country === 'nl') return ''
  return `${country}`
}


// WEBPACK FOOTER //
// ./resources/js/lib/local/country.js